// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import DatePicker from 'react-datepicker';
import moment from "moment";
import Card from '../../../components/card/Card';

class SessionHealth extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      batch_details:[],
      buddy_details:[],
      filtered_data:[],
      headers: [],
      buddy_headers:[],
      search:'',
      date: moment(),
      loading: false,
      customer_details: true,
      buddy_summary: false
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.onCustomerClick = this.onCustomerClick.bind(this);
    this.onBuddySummaryClick = this.onBuddySummaryClick.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getBatchHealth(this.state.venue);
    this.getBuddySummary(this.state.venue);
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getBatchHealth() 
      this.getBuddySummary()    
    })
  }

  onCustomerClick(){
    this.setState({customer_details:true,buddy_summary:false})
  }

  onBuddySummaryClick(){
    this.setState({customer_details:false,buddy_summary:true})
  }

  getBuddySummary() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=8999&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({buddy_details:data.data,buddy_headers:data.headers})
           // alert("fix");
       }).catch(error => error);
  }

  getBatchHealth() {
    const date = this.state.date.format('YYYY-MM-DD');
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7566&venue_id=${this.state.venue}&date=${date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({batch_details:data.data,headers:data.headers})
           // alert("fix");
       }).catch(error => error);
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }

  handleDate(date){
    this.setState({date:date},()=>{this.getBatchHealth();});
    
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

renderBuddy(){
   
    var headers = []
    if(this.state.buddy_details.length > 0){
      headers = Object.keys(this.state.buddy_details[0])
    }
    
    const headings = this.state.buddy_headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    return(
      <div className='col-md-12 table_container1 table-responsive'>
        <div className="heading heading2 left">Buddy Session Summary</div> 
        { this.state.buddy_details.length > 0 ?
          <ReactTable  
                      data={this.state.buddy_details}  
                      columns={headings}  
                      defaultPageSize = {100}  
                      pageSizeOptions = {[100,200,500]} 
                      filterable={true}
                      showPagination={this.state.buddy_details.length > 100}
                      showPaginationTop = {this.state.buddy_details.length > 100}
                      style = {{background:'#ddd'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          >
            {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#ddd'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
            }
          </ReactTable>
          :

          this.state.headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
          :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      )
  }
  renderCutsomers(){
   
    var headers = []
    if(this.state.batch_details.length > 0){
      headers = Object.keys(this.state.batch_details[0])
    }
    
    const headings = this.state.headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    return(
      <div className='col-md-12 table_container1 table-responsive' style={{marginTop:'2%'}}>
        
        <div style={{display:'flex',margin:'0%',paddingLeft:'1%',background:'#9370DB'}}>
          <div style={{marginTop:'7px'}}> Date - </div>
          <DatePicker selected={this.state.date} onChange={this.handleDate}/>
        </div>
        { this.state.batch_details.length > 0 ?
          <ReactTable  
                      data={this.state.batch_details}  
                      columns={headings}  
                      defaultPageSize = {100}  
                      pageSizeOptions = {[100,200,500]} 
                      filterable={true}
                      showPagination={this.state.batch_details.length > 100}
                      showPaginationTop = {this.state.batch_details.length > 100}
                      style = {{background:'#9370DB',textAlign:'center'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          >
            {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#9370DB'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
            }
          </ReactTable>
          :
          this.state.headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
          :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      )
  }

  render() {

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }
    

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    const StyledRoot = styled.div`
      padding: 0px;
      display: flex;
      flex-direction: row;
      margin-Bottom:5px;
      `
    const StyledContainer = styled.div`
      width: 100%;
      padding:4px;
      
      `
    
    console.log('props data',this.props)
    console.log('customer_data',this.state.customer_data)
    return(
      <div >
        <div >
          <StyledRoot className="col-md-12">
              <StyledContainer >
                <Card
                  title="Batch Health"
                  count={this.state.active_cust_count > 0 ? this.numberWithCommas(this.state.active_cust_count) : '-'}
                  action={"Contact"}
                  style={'#4daa0b'}
                  clicked={this.state.customer_details}
                  onClick={this.onCustomerClick}
                />
              </StyledContainer>

              <StyledContainer >
                <Card
                  title="Buddy Session Summary"
                  count={this.state.revenue_count > 0 ? this.numberWithCommas(this.state.revenue_count) : '-'}
                  action={"Contact"}
                  style={'#4daa0b'}
                  clicked={this.state.buddy_summary}
                  onClick={this.onBuddySummaryClick}
                />
              </StyledContainer>
        </StyledRoot>
        
        </div>

        <div className='col-md-12'>
          {this.state.customer_details  &&
            this.renderCutsomers()
          }

          {
            this.state.buddy_summary &&
            this.renderBuddy()
          }

        </div>  

      </div>
    );
  }
}

export default SessionHealth;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/sessionHealth/SessionHealth.js